module.exports = require('./helpers/bundle-url').getBundleURL('7pIAd') + "logo.7718c6df.svg";